<template>
  <div>
    <v-flex tag="h1" id="title-bar" xs12 :class="{'page-header-fab-padding': $vuetify.breakpoint.mdAndUp}">
      <!-- <v-icon style="position:absolute;left:0; top:6px;" color="secondary">alarm</v-icon> -->
      Timeline
    </v-flex>
    <!-- <div class="caption opacity-54 mb-1 text-uppercase primary--text">
      <PageTitle pageTitle="My Activity"></PageTitle>
    </div> -->
    <!-- <v-divider class="mb-3"></v-divider> -->
    <Timeline :timeline-days="timelineDays"></Timeline>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Timeline from '@/components/timeline/Timeline'

export default {
  name: "UserEvents",
  data: () => {
    return {
      title: "My Activity"
    }
  },
  computed: {
    ...mapState({
      timelineDays: state => state.timeline.current
    })
  },
  components: {
    Timeline
  }
}
</script>
